import { api } from "../../helpers/api/handler"

export const isSubscribed = () => api.get<boolean>("/auth/subscribe-status/")
